import { jsx as _jsx } from "react/jsx-runtime";
import { refX } from './MarkerDef.utils';
export function MarkerDef() {
    return (_jsx("defs", { children: _jsx("marker", { id: "arrowhead", markerWidth: "10", markerHeight: "7", refX: refX, refY: "3.5", orient: "auto", children: _jsx("polygon", { points: "0 0, 10 3.5, 0 7" }) }) }));
}
//# sourceMappingURL=MarkerDef.js.map